import { NavLink } from 'react-router-dom';

import { Gate, useAuth } from '../../../global/contexts/auth/auth';
import UsersOverview from '../../users/layouts/overview';
import TeamsOverview from '../../teams/layouts/overview';

import './styles/people.css';

// Personas y equipos, en una sección con dos pestañas.
//
// They used to be two entries in the rail. They are one question asked twice —
// who works here, and how they are grouped — and each answer is read while
// looking at the other: which teams is this person on, who is on this team. Two
// rail entries meant leaving one screen to check the other and losing the
// filter on the way.
//
// EACH TAB CARRIES ITS OWN PERMISSION, which is why the section declares `any`
// and not a single code. `users:read` and `teams:read` are separate in
// core/authz/roles.js, and somebody holding one of them gets the section with
// the other tab simply absent — not a tab that lands on /unauthorized.

const TABS = [
    { key: 'usuarios', title: 'Usuarios', domain: 'users:read' },
    { key: 'equipos',  title: 'Equipos',  domain: 'teams:read' },
];

export default function PeopleScreen({ tab }) {
    const { can } = useAuth();

    // The tab that was asked for, unless this account cannot read it — then the
    // first one it can. Landing on a tab that answers 403 is the same bug the
    // old `/` → /admin/clients redirect had, one level down.
    const allowed = TABS.filter(item => can(item.domain));
    const current = allowed.some(item => item.key === tab) ? tab : allowed[0]?.key;

    return (
        <section className="people">
            <header className="people__header">
                <h2 className="people__title">Usuarios y equipos</h2>
            </header>

            <nav className="people__tabs" aria-label="Secciones">
                {TABS.map(item => (
                    <Gate key={item.key} domain={item.domain}>
                        <NavLink
                            to={`/admin/people/${item.key}`}
                            className={() => (
                                // Marked from `current` and not from NavLink's
                                // own isActive: /admin/people with no tab shows
                                // one, and NavLink would call none of them active.
                                `people__tab ${item.key === current ? 'people__tab--active' : ''}`
                            )}
                            aria-current={item.key === current ? 'page' : undefined}
                        >
                            {item.title}
                        </NavLink>
                    </Gate>
                ))}
            </nav>

            <div className="people__panel">
                {current === 'usuarios' && <UsersOverview />}
                {current === 'equipos' && <TeamsOverview />}
                {!current && (
                    <p className="people__empty">
                        No tenés permiso para leer ni personas ni equipos.
                    </p>
                )}
            </div>
        </section>
    );
}
